<template>
  <div class="no-right-page">
    <exam-header :can-click-logo="true"></exam-header>
    <div class="no-right-card">
      <img class="no-right-icon" src="https://pandapub.nosdn.127.net/tmp1757489062_i9qxnb4btf0l4t_4trpr5a%3D%3D_2_1757485462_20.png" alt="no permission" />
      <div class="no-right-text">不好意思，您没有当前页面权限</div>
      <div class="back-btn">
        <router-link class="button" :to="{name: 'home'}">返回</router-link>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import teacherExamHeader from './teacher/components/teacherExamHeader.vue';
import PageFooter from '@/components/PageFooter.vue';
export default {
  name: 'NoRightPage',
  components: {
    'exam-header': teacherExamHeader,
    PageFooter
  },
  data() {
    return {

    }
  }
}
</script>

<style scoped>
.no-right-page {
  padding-top: 96px;
  /* padding-bottom: 40px; */
  background: #EDE4DA;
  height: 100vh;
  box-sizing: border-box;
  overflow: auto;
}

.no-right-card {
  margin: 0 auto;
  margin-bottom: 40px;
  /* min-height:800px; */
  width: 1200px;
  box-sizing: border-box;
  padding-top: 90px;
  padding-bottom: 90px;
  text-align: center;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
}

.no-right-icon {
  width: 225px;
  margin-bottom: 28px;
}

.no-right-text {
  color: #000000E5;
  font-size: 20px;
  font-weight: 600;
}
.back-btn {
  margin-top: 56px;
  width: 240px;
}
</style>
